/*
 * @Author: your name
 * @Date: 2022-03-17 21:50:56
 * @LastEditTime: 2022-10-14 15:40:57
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /streamline_detail/src/store/actions.ts
 */
import { getGoodInfo, getMoreInfo } from '@/apis/index'
import { getPlatByUa, getQueryString } from '@utils/index'
import { setState, state } from './index'
let infoId: string
let metric: string
let searchFrom: string
let orderId: string
let quickStart: string
let fromInstallment: string
const plat = getPlatByUa()
const REQUEST_TYPE = '1'
let addressId: string
let saleCombineIds: string

let version: string
let t: string
let ip: string
let uid: string
let initFrom: string
let search_metric: string
let clubIds: string
let packageId: string
/**
 * 使用预渲染技术时，location.href的值会被更新，所以通过url获得参数的方式，要有更新能力
 */
const initQueryParams = () => {
  infoId = getQueryString('infoId')
  metric = getQueryString('metric')
  searchFrom = getQueryString('searchFrom')
  orderId = getQueryString('orderId')
  quickStart = getQueryString('quickStart')
  addressId = getQueryString('addressId')
  saleCombineIds = getQueryString('saleCombineIds')
  fromInstallment = getQueryString('fromInstallment')
  search_metric = getQueryString('search_metric')
  clubIds = getQueryString('clubIds')
  packageId = getQueryString('packageId')

  // 后验逻辑客服需要的参数
  version = getQueryString('version')
  t = getQueryString('t')
  ip = getQueryString('ip')
  uid = getQueryString('uid')
  uid = getQueryString('uid')
  initFrom = getQueryString('init_from')

  if (infoId) {
    setState({
      infoId
    })
  }
  if (metric) {
    setState({
      metric
    })
  }
  if (orderId) {
    setState({
      orderId
    })
  }
  if (addressId) {
    setState({
      addressId
    })
  }
  if (fromInstallment) {
    setState({
      fromInstallment
    })
  }
  if (saleCombineIds) {
    setState({
      saleCombineIds
    })
  }

  if (version) {
    setState({ version })
  }
  if (t) {
    setState({ t })
  }
  if (ip) {
    setState({ ip })
  }
  if (uid) {
    setState({ uid })
  }

  if (initFrom) {
    setState({ initFrom })
  }
  if (search_metric) {
    setState({ search_metric })
  }

  if (clubIds) {
    setState({ clubIds })
  }

  if (packageId) {
    setState({ packageId })
  }
}

export class Actions {
  // $ 商品信息
  static async getGoodsInfoList() {
    // 经测试发现，promise的性能表现，比await要快50~100ms左右
    return new Promise((resolve, reject) => {
      try {
        initQueryParams()
        const start = new Date().getTime()
        getGoodInfo({
          infoId: infoId || state.infoId,
          requestType: fromInstallment || state.fromInstallment ? '3' : REQUEST_TYPE,
          plat,
          metric: metric || state.metric,
          rstmark: Date.now(),
          addressId: state.addressId || '',
          dsPageFlag: saleCombineIds && '1', // 区分是否是搭售商详
          packageId: packageId || '',
          version: state.version || '',
          t: state.t || '',
          ip: state.ip || '',
          uid: state.uid || '',
          initFrom: state.initFrom || ''
        }).then((response) => {
          const end = new Date().getTime()
          console.warn(`getGoodInfo接口耗时： ${end - start}`)
          const { data } = response
          if (data) {
            //响应式数据
            setState({
              collected: data.collected,
              couponsNewUser: data.couponsNewUser,
              coupons: data.coupons,
              couponsCharged: data.couponsCharged,
              newUserCouponPendant: data.newUserCouponPendant,
              showCouponsNewUser: data.showCouponsNewUser,
              actInfoVo: data.actInfoVo,
              cateId: data.cateLastId
            })
            resolve(data)
          } else {
            reject(new Error('未获取到正确的数据格式'))
          }
        })
      } catch (e) {
        console.log(e)
        reject(e)
      }
    })
  }

  // $ 质检报告信息
  static async getMoreInfoList() {
    try {
      initQueryParams()
      const { data = {} } = await getMoreInfo({
        infoId,
        orderId,
        requestType: fromInstallment || state.fromInstallment ? '3' : REQUEST_TYPE,
        searchFrom,
        quickStart: quickStart || state.quickStart,
        version: state.version || '',
        t: state.t || '',
        ip: state.ip || '',
        uid: state.uid || '',
        packageId: packageId || ''
      })
      console.log('质检报告信息打印 ==>', data)
      if (data) return data
    } catch (e) {
      console.log(e)
    }
  }
}
